export const URL_TYPES = {
	PLAIN: {
		title: "【予約特化型】Plain / プレーン",
	},
	MAGAZINE: {
		title: "【ストーリー訴求型】Magazine / マガジン",
	},
	SNACK: {
		title: "【ビジュアル訴求型】Snack / スナック",
	},
} as const;
